import { memo } from "react";
import { routeTabs } from "../../../consts/tabs";

import { SectionMenu } from "../components/SectionMenu";
import { DepotRouteDetail } from "../../DepotRouteDetail";

export const RouteManagementSections = memo(() => {
  return (
    <SectionMenu tabs={routeTabs}>
      <SectionMenu.SectionMenuItem id={0}>
        <DepotRouteDetail />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
